// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jrpw557G {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 2rem 1rem;
}
.yuTHIwBs {
  position: relative;
  width: 100%;
  max-width: 25.875rem;
  box-sizing: border-box;
  padding: 2.5875rem 2.3rem 2.3rem;
  background: #fffdf4;
  border-radius: 2.3rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);
  -webkit-animation: eyur50t1 0.3s ease;
          animation: eyur50t1 0.3s ease;
  overflow: visible;
  text-align: center;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
@media (max-width: 767px) {
  .yuTHIwBs {
    max-width: 90%;
    padding: 2.3rem 1.725rem 2.0125rem;
    border-radius: 2.0125rem;
  }
}
@-webkit-keyframes eyur50t1 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes eyur50t1 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.lAXgXUPt {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: -0.5rem;
  right: -1rem;
  width: 3.5rem;
  height: 3.5rem;
  padding: 0;
  border: none;
  background: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  z-index: 2;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.lAXgXUPt:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.lAXgXUPt:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .lAXgXUPt {
    top: -0.625rem;
    right: -0.875rem;
    width: 3rem;
    height: 3rem;
  }
}
.So3db6W_ {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
}
.rD7hWlHf {
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .rD7hWlHf {
    font-size: 1.25rem;
  }
}
.fviUVfxN {
  margin: 0 0 1.5rem;
  font-size: 1rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .fviUVfxN {
    font-size: 0.875rem;
  }
}
.Wh_cJu2W {
  margin: 0 0 2rem;
  font-size: 1.125rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.4;
  word-break: break-all;
}
@media (max-width: 767px) {
  .Wh_cJu2W {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
}
.aZcSH689 {
  background: none;
  padding: 0;
  outline: none;
  font-family: inherit;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.9375rem 1.5rem;
  background: #ff8100;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.125rem;
  font-weight: bold;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease, -webkit-transform 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  box-sizing: border-box;
}
.aZcSH689:hover {
  background: #e67400;
}
.aZcSH689:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .aZcSH689 {
    font-size: 1rem;
    padding: 0.875rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SupportModal/SupportModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAUA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EC8CA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;ED9CA,kBAAA;AAPF;AAUA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,gCAAA;EAEA,mBAAA;EACA,qBAAA;EACA,+CAAA;EACA,qCAAA;UAAA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,+EAAA;AATF;ACpBE;EAAA;IDgCE,cAAA;IACA,kCAAA;IAEA,wBAAA;EATF;AACF;AAYA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAVF;EAYA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAVF;AACF;AAEA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAVF;EAYA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAVF;AACF;AAaA;ECmDE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;EDtDA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AARF;AAUE;EACE,8BAAA;UAAA,sBAAA;AARJ;AAWE;EACE,8BAAA;UAAA,sBAAA;AATJ;AC/DE;EAAA;ID4EE,cAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;EATF;AACF;AAYA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAVF;AAaA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAXF;ACpFE;EAAA;IDkGE,kBAAA;EAVF;AACF;AAaA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAXF;AChGE;EAAA;ID8GE,mBAAA;EAVF;AACF;AAaA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAXF;AC7GE;EAAA;ID2HE,eAAA;IACA,qBAAA;EAVF;AACF;AAaA;EC3BE,gBAAA;EACA,UAAA;EAGA,aAAA;EACA,oBAAA;EDwBA,cAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,+EAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,2EAAA;EAAA,mEAAA;EAAA,2DAAA;EAAA,wFAAA;EC/BA,mBAAA;EACA,kBAAA;EDgCA,sBAAA;AAPF;AASE;EACE,mBAAA;AAPJ;AAUE;EACE,8BAAA;UAAA,sBAAA;AARJ;AC/IE;EAAA;ID2JE,eAAA;IACA,sBAAA;EARF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@support-modal-bg: #fffdf4;\n@support-modal-text: #5e5447;\n@support-modal-orange: #ff8100;\n@support-modal-orange-dark: #e67400;\n@support-modal-scale: 1.15;\n@support-modal-base-width: 22.5rem;\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-xl @spacing-md;\n}\n\n.modal {\n  position: relative;\n  width: 100%;\n  max-width: (@support-modal-base-width * @support-modal-scale);\n  box-sizing: border-box;\n  padding: (2.25rem * @support-modal-scale) (2rem * @support-modal-scale)\n    (2rem * @support-modal-scale);\n  background: @support-modal-bg;\n  border-radius: (2rem * @support-modal-scale);\n  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);\n  animation: slideUp 0.3s ease;\n  overflow: visible;\n  text-align: center;\n  font-family: @font-family-sans;\n\n  .mobile({\n    max-width: 90%;\n    padding: (2rem * @support-modal-scale) (1.5rem * @support-modal-scale)\n      (1.75rem * @support-modal-scale);\n    border-radius: (1.75rem * @support-modal-scale);\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: -0.5rem;\n  right: -1rem;\n  width: 3.5rem;\n  height: 3.5rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    top: -0.625rem;\n    right: -0.875rem;\n    width: 3rem;\n    height: 3rem;\n  });\n}\n\n.closeButtonImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.title {\n  margin: 0 0 @spacing-md;\n  font-size: @font-size-xxl;\n  font-weight: bold;\n  color: @support-modal-text;\n  line-height: 1.3;\n\n  .mobile({\n    font-size: @font-size-xl;\n  });\n}\n\n.description {\n  margin: 0 0 @spacing-lg;\n  font-size: @font-size-md;\n  font-weight: bold;\n  color: @support-modal-text;\n  line-height: 1.5;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.email {\n  margin: 0 0 @spacing-xl;\n  font-size: @font-size-lg;\n  font-weight: bold;\n  color: @support-modal-text;\n  line-height: 1.4;\n  word-break: break-all;\n\n  .mobile({\n    font-size: @font-size-md;\n    margin-bottom: @spacing-lg;\n  });\n}\n\n.copyButton {\n  .button-reset();\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0.9375rem @spacing-lg;\n  background: @support-modal-orange;\n  border: none;\n  border-radius: 999px;\n  color: @white;\n  font-family: @font-family-sans;\n  font-size: @font-size-lg;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  .touch-friendly();\n  box-sizing: border-box;\n\n  &:hover {\n    background: @support-modal-orange-dark;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-md;\n    padding: 0.875rem @spacing-md;\n  });\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `jrpw557G`,
	"modal": `yuTHIwBs`,
	"slideUp": `eyur50t1`,
	"closeButton": `lAXgXUPt`,
	"closeButtonImg": `So3db6W_`,
	"title": `rD7hWlHf`,
	"description": `fviUVfxN`,
	"email": `Wh_cJu2W`,
	"copyButton": `aZcSH689`
};
export default ___CSS_LOADER_EXPORT___;
